import { Language } from "../languages";

export const homeTranslations: Record<Language, any> = {
  es: {
    news: {
      title: "Últimas Noticias",
      error:
        "No se pudieron cargar las noticias. Inténtalo de nuevo más tarde.",
      noNews: "No hay noticias disponibles.",
      noVideoSupport: "Tu navegador no soporta la reproducción de video.",
      readMore: "Leer más",
    },
    features: {
      title: "Características Épicas",
      items: {
        combat: {
          title: "Combate Mágico",
          description:
            "Domina el caos residual y habilidades especiales en combates estratégicos contra criaturas legendarias",
        },
        world: {
          title: "Mundo Encantado",
          description:
            "Explora ciudades destruidas, dimensiones ocultas y reinos de bolsillo creados por dioses tenebrosos",
        },
        legends: {
          title: "Leyendas Ancestrales",
          description:
            "Descubre secretos milenarios que cambiarán el destino del mundo y sus habitantes",
        },
        characters: {
          title: "Personajes Únicos",
          description:
            "Conoce a los héroes y villanos que habitan este mundo, cada uno con su propia historia y habilidades únicas.",
        },
        magic: {
          title: "Magia Asombrosa",
          description:
            "Descubre hechizos poderosos, artefactos antiguos y secretos arcanos que cambiarán el curso de la historia.",
        },
        castles: {
          title: "Castillos Imponentes",
          description:
            "Explora majestuosos castillos, cada uno con su propia historia y secretos por descubrir.",
        },
      },
    },
  },
  en: {
    news: {
      title: "Latest News",
      error: "Failed to load news. Please try again later.",
      noNews: "No news available.",
      noVideoSupport: "Your browser does not support video playback.",
      readMore: "Read more",
    },
    features: {
      title: "Epic Features",
      items: {
        combat: {
          title: "Magical Combat",
          description:
            "Master residual chaos and special abilities in strategic battles against legendary creatures",
        },
        world: {
          title: "Enchanted World",
          description:
            "Explore ruined cities, hidden dimensions, and pocket realms created by dark gods",
        },
        legends: {
          title: "Ancestral Legends",
          description:
            "Discover ancient secrets that will change the fate of the world and its inhabitants",
        },
        characters: {
          title: "Unique Characters",
          description:
            "Meet the heroes and villains that inhabit this world, each with their own story and unique abilities.",
        },
        magic: {
          title: "Amazing Magic",
          description:
            "Discover powerful spells, ancient artifacts, and arcane secrets that will change the course of history.",
        },
        castles: {
          title: "Imposing Castles",
          description:
            "Explore majestic castles, each with its own story and secrets to uncover.",
        },
      },
    },
  },
};
